import MonixModal from '@/global/components/monix-modal';
import './index.less';
import { useEffect, useRef, useState } from 'react';
import { Button, Form, Input, Select, Spin } from 'antd';
import { GENDER_TYPE, USER_TYPE } from '@/enums/user';
import { getPositions } from '@/api/lib/position';
import { Position } from '@/global/interface/project-manage/position';
import TnMessage from '@/global/components/message';
import { addUser } from '@/api/lib/user';

interface IProps {
    showModel: boolean
    setShowModel: (v: boolean) => void
    loading: boolean
    onSuccess: () => void
}

export default function AddUserModal(props: IProps) {

    const [form] = Form.useForm();
    const btnRef = useRef(null);
    const [loading, setLoading] = useState<boolean>(false); // loading
    const [positions, setPositions] = useState<Position[]>([]); // 可选职位

    // 获取职位
    useEffect(() => {
        if (props.showModel) {
            getPositions().then(res => {
                if (res.status === 200) {
                    let data: Position[] = res.data || [];
                    setPositions(data);
                }
            }).catch(err => {
                TnMessage.error("获取职位失败");
            })
        } else {
            form.resetFields();
        }
    }, [props.showModel])

    // 校验邮箱
    const validateEmail = (rule, value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!value || emailRegex.test(value)) {
            return Promise.resolve();
        }
        return Promise.reject('请输入有效的邮箱格式');
    };

    // 校验手机号
    const validateMobile = (rule, value) => {
        const mobileRegex = /^1[3-9]\d{9}$/;
        if (!value || mobileRegex.test(value)) {
            return Promise.resolve();
        }
        return Promise.reject('请输入有效的手机号');
    };

    // 点击确认按钮
    const onSaveClick = () => {
        if (btnRef.current) {
            btnRef.current.click();
        }
    }

    // 添加用户回调
    const onFinish = (value) => {
        setLoading(true);
        addUser(value).then(res => {
            if (res.status === 200) {
                TnMessage.success("添加成功");
                props.onSuccess();
            }
        }).catch(err => {
            TnMessage.error(err?.data || '添加失败');
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <MonixModal
            title={"添加用户"}
            visible={props.showModel}
            setVisible={(e) => props.setShowModel(e)}
            onSaveClick={onSaveClick}
            wrapClassName="form-modal"
            saveDisable={loading}
        >
            <Spin wrapperClassName="form-body" spinning={props.loading}>
                <Form
                    colon={false}
                    form={form}
                    autoComplete="off"
                    labelCol={{ span: 6 }}
                    onFinish={onFinish}
                    initialValues={{
                        type: USER_TYPE.NORMAL
                    }}
                >
                    <Form.Item label="姓名:" name="name" rules={[{ required: true, message: '姓名不能为空' }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label="性别:" name="gender" rules={[{ required: true, message: '性别不能为空' }]}>
                        <Select>
                            <Select.Option value={GENDER_TYPE.MALE}>男</Select.Option>
                            <Select.Option value={GENDER_TYPE.FAMALE}>女</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="用户名:" name="username" rules={[{ required: true, message: '用户名不能为空' }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label="密码:" name="password">
                        <Input type='password' />
                    </Form.Item>
                    <Form.Item label="类型:" name="type">
                        <Select>
                            <Select.Option value={USER_TYPE.ADMIN}>管理员</Select.Option>
                            <Select.Option value={USER_TYPE.NORMAL}>普通用户</Select.Option>
                            <Select.Option value={USER_TYPE.TEST}>演示账号</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="手机号:" name="mobile" rules={[{ validator: validateMobile }]}>
                        <Input />
                    </Form.Item>

                    <Form.Item label="电子邮箱:" name="email" rules={[{ validator: validateEmail }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label="企业:" name="enterprise">
                        <Input />
                    </Form.Item>
                    <Form.Item label="地址:" name="address">
                        <Input />
                    </Form.Item>
                    <Form.Item label="部门:" name="department">
                        <Input />
                    </Form.Item>
                    <Form.Item label="职位:" name="positionId">
                        <Select>
                            {positions?.map((item, key) => (
                                <Select.Option key={key} value={item?.id}>{item?.name || ''}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Button ref={btnRef} htmlType="submit" style={{ display: 'none' }}></Button>
                </Form>
            </Spin>
        </MonixModal>
    )
}